export default __webpack_public_path__ + "static/media/large_logo_holder.38b8fb03.svg";